
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as index4zahBmQFUNq2qaahtwKP3B7eG5okD9iNwjr0UEQcMDEMeta } from "/app/layers/faq/pages/faq/index.vue?macro=true";
import { default as _91id_93dAedRYlgIRe8d11JpgHv22hKm1TKGdIr93Yg564UAvwMeta } from "/app/layers/webform/pages/form/[id].vue?macro=true";
import { default as indexGjVM06DeghNeOYWDvlV7r0s4_45XnyXprPvWBT3HQDxbcMeta } from "/app/layers/anura/pages/anura/index.vue?macro=true";
import { default as _91id_934zZ_rdsHVPcqhIWFIGx0N5eEaPzPUQ_45n_45WdWPHpIkckMeta } from "/app/pages/storage/[id].vue?macro=true";
import { default as indexZWU7EVhpVcp6cDYY5QIwwaxl3hXrEW6fOG7fFDqQQooMeta } from "/app/pages/[...slug]/index.vue?macro=true";
import { default as _91nid_93do3Pe88DdRpBvJKuOw6NlW_7Ip5dhhXkNK7ynFwljpoMeta } from "/app/layers/tomasBooking/pages/buy-tickets/[nid].vue?macro=true";
import { default as buttons_45linksssOkuDBwZEnas57yo_45VXWCkeGye33lgt20wIelX6smcMeta } from "/app/layers/dev/pages/dev/buttons-links.vue?macro=true";
import { default as indexRyr8Vj2KJ9FiEme6H2fFN9afJfZaq8J6do0YDdDlzNQMeta } from "/app/layers/legacy-search/pages/search-page/index.vue?macro=true";
import { default as _91nid_9386dtLFwUT10JlEcFWCR_45XEPy9syuIiP6y39_UZsQ0NUMeta } from "/app/layers/hotel-availability/pages/availability/[nid].vue?macro=true";
import { default as indexxy2gBGC80YgjsZafjpZeM95T5biMDH6rOV7GXAGmiooMeta } from "/app/layers/neighborhood-guide/pages/neighborhood/index.vue?macro=true";
import { default as index_45vx_45MivJInEAqJ3LWSUEU5OZmLw9GI4NcN7_N5SDzWMMeta } from "/app/layers/dev/pages/dev/icons-debug/index.vue?macro=true";
import { default as _91nid_93fn48jgijSLvM4beRkexTEU28ZoKNi1w1xmtIbYiESfUMeta } from "/app/layers/tomasBooking/pages/book-public-tour/[nid].vue?macro=true";
import { default as indexXAEKFebcaxbkaqJ3qS7I3OTdQazbOCVRtPfioZxe_45DsMeta } from "/app/layers/dev/pages/dev/debug-formkit/index.vue?macro=true";
import { default as indexIiLI7BePAJ9cg6iO2_45HP6Hm051hBf8uY94Zpwnvup3UMeta } from "/app/layers/dev/pages/dev/trigger-error/index.vue?macro=true";
import { default as indexIrP6QnErNYmjJv9o3jkI102F3lL4mes50LUsBIrUDw0Meta } from "/app/layers/dev/pages/dev/debug-paragraphs/index.vue?macro=true";
import { default as _91uuid_93qdIhcUtoBohh9EU3WJ7BYKPDNUT_HOrPYZnlC_45cxPTsMeta } from "/app/pages/blokkli/library-item/[uuid].vue?macro=true";
import { default as indexeN49gVLNM5mMGbcu48HFZM9loW1HZ_45Fa9YtGagLQbZEMeta } from "/app/layers/neighborhood-guide/pages/neighborhood/[region]/index.vue?macro=true";
export default [
  {
    name: "home",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "faq",
    path: "/de/faq",
    meta: index4zahBmQFUNq2qaahtwKP3B7eG5okD9iNwjr0UEQcMDEMeta || {},
    component: () => import("/app/layers/faq/pages/faq/index.vue")
  },
  {
    name: "form-id",
    path: "/form/:id()",
    component: () => import("/app/layers/webform/pages/form/[id].vue")
  },
  {
    name: "anura",
    path: "/en/business/media/image-and-video-material",
    meta: indexGjVM06DeghNeOYWDvlV7r0s4_45XnyXprPvWBT3HQDxbcMeta || {},
    component: () => import("/app/layers/anura/pages/anura/index.vue")
  },
  {
    name: "storage-canonical",
    path: "/storage/:id()",
    meta: _91id_934zZ_rdsHVPcqhIWFIGx0N5eEaPzPUQ_45n_45WdWPHpIkckMeta || {},
    component: () => import("/app/pages/storage/[id].vue")
  },
  {
    name: "drupal-route",
    path: "/:slug(.*)*",
    meta: indexZWU7EVhpVcp6cDYY5QIwwaxl3hXrEW6fOG7fFDqQQooMeta || {},
    component: () => import("/app/pages/[...slug]/index.vue")
  },
  {
    name: "buy-tickets-nid",
    path: "/buy-tickets/:nid()",
    component: () => import("/app/layers/tomasBooking/pages/buy-tickets/[nid].vue")
  },
  {
    name: "dev-buttons-links",
    path: "/dev/buttons-links",
    component: () => import("/app/layers/dev/pages/dev/buttons-links.vue")
  },
  {
    name: "search-page",
    path: "/search-page",
    meta: indexRyr8Vj2KJ9FiEme6H2fFN9afJfZaq8J6do0YDdDlzNQMeta || {},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  },
  {
    name: "hotel-availability",
    path: "/availability/:nid()",
    meta: _91nid_9386dtLFwUT10JlEcFWCR_45XEPy9syuIiP6y39_UZsQ0NUMeta || {},
    component: () => import("/app/layers/hotel-availability/pages/availability/[nid].vue")
  },
  {
    name: "neighborhood-guide",
    path: "/de/neighborhood",
    meta: indexxy2gBGC80YgjsZafjpZeM95T5biMDH6rOV7GXAGmiooMeta || {},
    component: () => import("/app/layers/neighborhood-guide/pages/neighborhood/index.vue")
  },
  {
    name: "dev-icons-debug",
    path: "/dev/icons-debug",
    component: () => import("/app/layers/dev/pages/dev/icons-debug/index.vue")
  },
  {
    name: "book-public-tour-nid",
    path: "/book-public-tour/:nid()",
    component: () => import("/app/layers/tomasBooking/pages/book-public-tour/[nid].vue")
  },
  {
    name: "dev-debug-formkit",
    path: "/dev/debug-formkit",
    component: () => import("/app/layers/dev/pages/dev/debug-formkit/index.vue")
  },
  {
    name: "dev-trigger-error",
    path: "/dev/trigger-error",
    component: () => import("/app/layers/dev/pages/dev/trigger-error/index.vue")
  },
  {
    name: "dev-debug-paragraphs",
    path: "/dev/debug-paragraphs",
    component: () => import("/app/layers/dev/pages/dev/debug-paragraphs/index.vue")
  },
  {
    name: "blokkli-library-item-uuid",
    path: "/blokkli/library-item/:uuid()",
    meta: _91uuid_93qdIhcUtoBohh9EU3WJ7BYKPDNUT_HOrPYZnlC_45cxPTsMeta || {},
    component: () => import("/app/pages/blokkli/library-item/[uuid].vue")
  },
  {
    name: "neighborhood-region",
    path: "/neighborhood/:region()",
    component: () => import("/app/layers/neighborhood-guide/pages/neighborhood/[region]/index.vue")
  },
  {
    name: "search-what-to-do-zurich",
    path: "/de/zuerich-erleben",
    meta: {"languageMapping":{"de":"/de/zuerich-erleben","en":"/en/discover-zurich","it":"/it/vivere-zurigo","fr":"/fr/decouvrez-zurich"},"searchSiteId":"search-what-to-do-zurich"},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  },
  {
    name: "search-what-to-do-rapperswil",
    path: "/de/erlebnisse-in-der-region-zuerichsee",
    meta: {"languageMapping":{"de":"/de/erlebnisse-in-der-region-zuerichsee","en":"/en/erlebnisse-in-der-region-zuerichsee","it":"/it/erlebnisse-in-der-region-zuerichsee","fr":"/fr/erlebnisse-in-der-region-zuerichsee"},"searchSiteId":"search-what-to-do-rapperswil"},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  },
  {
    name: "search-tours-zurich",
    path: "/de/fuehrungen-ausfluege-in-zuerich",
    meta: {"languageMapping":{"de":"/de/fuehrungen-ausfluege-in-zuerich","en":"/en/tours-in-zurich","it":"/it/visite-guidate-a-zurigo","fr":"/fr/visites-guidees-a-zurich"},"searchSiteId":"search-tours-zurich"},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  },
  {
    name: "search-tours-rapperswil",
    path: "/de/fuehrungen-gruppenangebote-in-der-region-zuerichsee",
    meta: {"languageMapping":{"de":"/de/fuehrungen-gruppenangebote-in-der-region-zuerichsee","en":"/en/fuehrungen-gruppenangebote-in-der-region-zuerichsee","it":"/it/fuehrungen-gruppenangebote-in-der-region-zuerichsee","fr":"/fr/fuehrungen-gruppenangebote-in-der-region-zuerichsee"},"searchSiteId":"search-tours-rapperswil"},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  },
  {
    name: "search-hotel-zurich",
    path: "/de/uebernachten-zuerich-hotel-bed-and-breakfast-hostel",
    meta: {"languageMapping":{"de":"/de/uebernachten-zuerich-hotel-bed-and-breakfast-hostel","en":"/en/hotels-bbs-apartments-and-hostels-your-accommodation-in-zurich","it":"/it/dove-dormire-a-zurigo","fr":"/fr/tous-les-hebergements-a-zurich"},"searchSiteId":"search-hotel-zurich"},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  },
  {
    name: "search-hotel-rapperswil",
    path: "/de/hotel-bed-and-breakfast-zeltplatz-uebernachten-zuerichsee",
    meta: {"languageMapping":{"de":"/de/hotel-bed-and-breakfast-zeltplatz-uebernachten-zuerichsee","en":"/en/hotels-bbs-and-camping-site-find-your-accomodation-around-lake-zurich","it":"/it/hotel-bed-and-breakfast-zeltplatz-uebernachten-zuerichsee","fr":"/fr/hotel-bed-and-breakfast-zeltplatz-uebernachten-zuerichsee"},"searchSiteId":"search-hotel-rapperswil"},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  },
  {
    name: "search-hotel-eyz",
    path: "/de/besuchen/unterkunft/alle-angebote",
    meta: {"languageMapping":{"de":"/de/besuchen/unterkunft/alle-angebote","en":"/en/besuchen/unterkunft/alle-angebote","it":"/it/besuchen/unterkunft/alle-angebote","fr":"/fr/besuchen/unterkunft/alle-angebote"},"searchSiteId":"search-hotel-eyz"},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  },
  {
    name: "search-hotel-hoteljobs",
    path: "/de/hotel-uebersicht",
    meta: {"languageMapping":{"de":"/de/hotel-uebersicht","en":"/en/hotel-uebersicht","it":"/it/hotel-uebersicht","fr":"/fr/hotel-uebersicht"},"searchSiteId":"search-hotel-hoteljobs"},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  },
  {
    name: "search-venues",
    path: "/de/business/zuerich-vielfalt-eventlokalitaeten",
    meta: {"languageMapping":{"de":"/de/business/zuerich-vielfalt-eventlokalitaeten","en":"/en/business/zurich-a-diverse-range-of-event-venues","it":"/it/business/zuerich-vielfalt-eventlokalitaeten","fr":"/fr/business/zuerich-vielfalt-eventlokalitaeten"},"searchSiteId":"search-venues"},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  },
  {
    name: "search-incentives",
    path: "/de/business/die-perfekten-rahmenprogramme-fuer-ihre-events-in-zuerich",
    meta: {"languageMapping":{"de":"/de/business/die-perfekten-rahmenprogramme-fuer-ihre-events-in-zuerich","en":"/en/business/the-perfect-social-programs-for-your-events-in-zurich","it":"/it/business/die-perfekten-rahmenprogramme-fuer-ihre-events-in-zuerich","fr":"/fr/business/die-perfekten-rahmenprogramme-fuer-ihre-events-in-zuerich"},"searchSiteId":"search-incentives"},
    component: () => import("/app/layers/legacy-search/pages/search-page/index.vue")
  }
]